module.exports = __webpack_public_path__ + "static/img/shouye4.a358f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/shouye4.png
// module id = /4WN
// module chunks = 17